import React, { useState, useEffect } from 'react'

import { Header } from '../../components/header/header'
import { NavBar } from '../../components/navBar/navbar'
import { Menu } from '../../components/menu/menu.jsx'
import LoadContainer from '../../components/loading'
import './styles.css'
import Cookies from 'js-cookie'
import { getPersonalData, updateUserData } from '../../services/api'

const UserPage = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [name, setName] = useState('')
	const [email, setEmail] = useState('')
	const [phonesArray, setPhonesArray] = useState([''])
	const [type, setType] = useState('')
	const [idShown, setIdShown] = useState('')
	const [realCode, setRealCode] = useState('')
	const [address, setAddress] = useState('')
	const [postalCode, setPostalCode] = useState('')
	const [password, setPassword] = useState('')

	const [formDisabled, setFormDisabled] = useState(false)

	const maskId = (code) => {
		if (!code) {
			return ''
		}
		const astInit = '***'
		const astEnd = '-**'
		return astInit + code?.slice(3, 9) + astEnd
	}

	const handlePhoneChange = (e, index) => {
		const newPhones = [...phonesArray]
		newPhones[index] = e.target.value
		setPhonesArray(newPhones)
	}

	const handleCode = (e) => {
		activateField(e)
		setIdShown('')
	}

	useEffect(() => {
		;(async () => {
			setIsLoading(true)
			const { data } = await getPersonalData()
			setRealCode(data.id_code)
			const code = maskId(data.id_code)
			setIdShown(code)
			setAddress(data.address)
			setPostalCode(data.postal_code)
			const newPhones = [...phonesArray]
			for (let i = 0; i < data.phones.length; i++) {
				newPhones[i] = data.phones[i].phone_number
				setPhonesArray(newPhones)
			}
			const userData = Cookies.get('user')
			if (userData) {
				const user = JSON.parse(userData)
				setName(user.name.toUpperCase())
				setEmail(user.email.toLowerCase())
				setType(user.type)
			}
			setIsLoading(false)
		})()
	}, [])

	const removeField = (index) => {
		const removingArray = [...phonesArray]
		removingArray.splice(index, 1)
		setPhonesArray(removingArray)
	}

	const addPhoneField = () => {
		setPhonesArray([...phonesArray, ''])
	}

	const goHome = () => {
		window.location.href = '/home'
	}

	const activateField = (e) => {
		e.target.removeAttribute('disabled')
		e.target.focus()
	}

	const handleSubmit = async (e) => {
		e.preventDefault()
		setFormDisabled(true)
		const userDataUpdate = {
			id_code: idShown.includes('*') ? realCode : idShown,
			address: address,
			postal_code: postalCode,
			phones: phonesArray,
			password: password,
		}
		try {
			const response = await updateUserData(userDataUpdate)
			alert('Atualizações Salvas!')
		} catch (error) {
			alert('Erro ao enviar dados')
		} finally {
			window.location.reload()
		}
	}
	return (
		<div className="user-page">
			<Menu></Menu>
			<NavBar></NavBar>
			<div className="user-column">
				<Header></Header>
				<span className="material-symbols-outlined goback" onClick={goHome}>
					arrow_back
				</span>
				<h1 className="user-title">Minha Conta</h1>
				{isLoading ? <LoadContainer></LoadContainer> : ''}
				<div className="form-container">
					<form className="user-form" autoComplete="off" onSubmit={handleSubmit}>
						<div className="name-email-container">
							<div className="field">
								<label htmlFor="name" className="user-label">
									Nome
								</label>
								<input
									type="text"
									name="name"
									className="user-input"
									onChange={(e) => setName(e.target.value)}
									value={name}
									disabled={true}
									required
								></input>
							</div>
							<div className="field">
								<label htmlFor="email" className="user-label">
									Email
								</label>
								<input
									name="email"
									type="email"
									onChange={(e) => setEmail(e.target.value)}
									className="user-input"
									value={email}
									disabled={true}
									required
								></input>
							</div>
							<div className="field">
								<label className="user-label">Tipo</label>
								<input
									type="text"
									disabled={true}
									className="user-input"
									value={`Pessoa ${type === 0 ? 'Física' : 'Jurídica'}`}
								/>
							</div>
						</div>
						<span className="info-msg">Selecione um campo abaixo para editar</span>
						<div className="editable-container">
							<div className="field phones-container" onClick={activateField}>
								<label className="user-label">Telefone:</label>
								<span className="material-symbols-outlined btnAdd" onClick={addPhoneField}>
									add
									<span className="addNumberTxt">Adicionar mais um número</span>
								</span>
								<div className="phone-field">
									{phonesArray.map((phone, index) => (
										<div key={index} className="phoneRow">
											<input
												type="tel"
												placeholder="(xx)xxxxx-xxxx"
												className="user-input phone-input"
												onChange={(e) => handlePhoneChange(e, index)}
												disabled={true}
												value={phone}
												required
											></input>
											<span
												className="material-symbols-outlined btnAdd"
												onClick={() => removeField(index)}
											>
												Remove
											</span>
										</div>
									))}
								</div>
							</div>

							<div className="field" onClick={(e) => handleCode(e)}>
								<label htmlFor="cpf" className="user-label">
									{type === 0 ? 'CPF' : 'CNPJ'}
								</label>
								<input
									name="cpf"
									id="cpf"
									type="text"
									className="user-input"
									onChange={(e) => setIdShown(e.target.value)}
									value={idShown}
									disabled={true}
									required
								></input>
							</div>
							<div className="field" onClick={activateField}>
								<label className="user-label">Endereço</label>
								<input
									type="text"
									className="user-input"
									onChange={(e) => setAddress(e.target.value)}
									value={address}
									disabled={true}
									required
								></input>
							</div>
							<div className="field" onClick={activateField}>
								<label className="user-label">CEP</label>
								<input
									type="number"
									className="user-input"
									onChange={(e) => setPostalCode(e.target.value)}
									value={postalCode}
									disabled={true}
									required
								></input>
							</div>
							<div className="field">
								<label className="user-label password-label">
									Confirme sua senha para salvar os dados:
								</label>
								<input
									type="password"
									className="user-input password-input"
									onChange={(e) => setPassword(e.target.value)}
									value={password}
									autoComplete="new-password"
									required
								></input>
							</div>
						</div>
						<div className="action-field">
							<input disabled={formDisabled} type="submit" className="user-submit" value="Salvar"></input>
						</div>
					</form>
				</div>
			</div>
		</div>
	)
}

export default UserPage
